import AppContainer from '../basicLayout/AppContainer'
export default [
    {
        path: '/superviseSys',
        name: 'supervise_sys_management',
        component: AppContainer,
        meta: {
            title: '系统管理'
        },
        children: [
            {
                path: 'superviseDept',
                name: 'SuperviseDept',
                meta: {
                    title: '部门管理'
                },
                component: resolve => require(['@/views/supervise/sys/org/index.vue'], resolve)
            },
            {
                path: 'superviseRole',
                meta: {
                    title: '角色管理'
                },
                name: 'SuperviseRole',
                component: resolve => require(['@/views/supervise/sys/role/index.vue'], resolve)
            },

            {
                path: 'superviseUser',
                meta: {
                    title: '用户管理'
                },
                name: 'SuperviseUser',
                component: resolve => require(['@/views/supervise/sys/user/index.vue'], resolve)
            },
            {
                path: 'supervisePost',
                meta: {
                    title: '岗位管理'
                },
                name: 'SupervisePost',
                component: resolve => require(['@/views/supervise/sys/post/index.vue'], resolve)
            },
            {
                path: 'superviseDict',
                meta: {
                    title: '字典管理'
                },
                name: 'SuperviseDict',
                component: resolve => require(['@/views/supervise/sys/dict/index.vue'], resolve)
            }
        ]
    },
    {
        path: '/superviseVehicleRegulation',
        name: 'supervise_vehicle_regulation',
        component: AppContainer,
        meta: {
            title: '车辆监管'
        },
        children: [
            {
                path: 'superviseMoreCarTrack',
                meta: {
                    title: '多车跟踪'
                },
                name: 'SuperviseMoreCarTrack',
                component: resolve => require(['@/views/supervise/moreCar/index.vue'], resolve)
            },
            {
                path: 'countCarInMap',
                meta: {
                    title: '行车地图'
                },
                name: 'CountCarInMap',
                component: resolve => require(['@/views/supervise/countCarInMap/index.vue'], resolve)
            }
        ]
    },
]
